import cookie from 'js-cookie'
import server from '../statics/server';
import Axios from 'axios';
import moment from 'moment';

export default {
	data: function() {
		return {
			Authorization: "",
			login: { }
		}
	},
	mounted: function() {
		// 엑세스토큰이 존재하는지 확인
		const token = cookie.get("access_token");
		if(!token) {
			// 토큰이 존재하지 않으면 로그인화면으로 이동
			this.$router.push("/").catch(() => {});
		} else {
			const expire_time = cookie.get("expire_time");
			const now = moment(new Date())
			const flag_time = moment.duration(now.diff(expire_time));
			if(flag_time.asMinutes() > 15) {
				// 토큰이 존재하면 토큰이 유효한지 확인
				this.getLoginInfo().then( (response) => {
					if(response.data.msg!="성공") {
						// 토큰이 유효하지 않으면, 저장된 토큰을 지우고 로그인화면으로 이동
						this.setAccessToken("");
						this.$router.push("/").catch(() => {});
					}
				}).catch( () => {
					// 토큰이 유효하지 않으면, 저장된 토큰을 지우고 로그인화면으로 이동
					this.setAccessToken("");
					this.$router.push("/").catch(() => {});
				})
			}
		}
	},
	methods: {
		tokenInitializer: function() {
			const token = cookie.get("access_token");
			if(!token) { return; }
			this.setAccessToken(token);
		},
		setAccessToken: function(token) {
			this.Authorization = "Bearer " + token;
			cookie.set("access_token", token);
			cookie.set("expire_time", moment().format('YYYY-MM-DD HH:mm'));
			Axios.defaults.headers.common['Authorization'] = this.Authorization;
		},
		getLoginInfo: function() {
			return Axios.post(`${server.addr()}${server.api.AUTHORIZATION}`);
		},
		getAuthInfo: async function() {
			return await this.getLoginInfo().then((response) => {
				let auth = {"관리자 권한":[], "강사 권한":[], "CMS 권한":[], "관리자 메뉴":{}};
				response.data.return.authAllotList.forEach( (authRecord) => {
					let temp = JSON.parse(authRecord.authJson);
					if(temp["관리자 권한"]) temp["관리자 권한"].forEach((a) => {
						if(a.permission) {
							if(!auth["관리자 권한"].find(e=>e.name==a.name)) {
								auth["관리자 권한"][a.name] = {...a};
							}
						}
					})
					if(temp["강사 권한"]) temp["강사 권한"].forEach((a) => {
						if(a.permission) {
							if(!auth["강사 권한"].find(e=>e.name==a.name)) {
								auth["강사 권한"].push({...a});
							}
						}
					})
					if(temp["CMS 권한"]) temp["CMS 권한"].forEach((a) => {
						if(a.permission) {
							if(!auth["CMS 권한"].find(e=>e.name==a.name)) {
								auth["CMS 권한"].push({...a});
							}
						}
					})
					if(temp["관리자 메뉴"]) Object.keys(temp["관리자 메뉴"]).forEach((k) => {
						if(!auth["관리자 메뉴"][k]) auth["관리자 메뉴"][k] = {};
						if(temp["관리자 메뉴"][k].enabled) {
							auth["관리자 메뉴"][k].enabled = true;
							Object.keys(temp["관리자 메뉴"][k]).forEach((ck) => {
								if(ck=="enabled") return;
								if(!auth["관리자 메뉴"][k][ck]) auth["관리자 메뉴"][k][ck] = {};
								if(temp["관리자 메뉴"][k][ck].enabled)
									auth["관리자 메뉴"][k][ck].enabled = true;
							})
						}
					})
				});
				return auth;
			});
		}
	}
}